import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { DELETE_AUTH_USER_CONFIRMATION_TEXT } from './constants';

@Component({
  selector: 'app-delete-auth-user-dialog',
  templateUrl: './delete-auth-user-dialog.component.html',
  styleUrls: ['./delete-auth-user-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAuthUserDialogComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);
  private readonly context = injectContext<TuiDialogContext<boolean>>();

  confirmationText: string = this.translateService.instant(DELETE_AUTH_USER_CONFIRMATION_TEXT);

  readonly form = new UntypedFormGroup({
    enteredText: new UntypedFormControl('', [Validators.required, Validators.pattern(this.confirmationText)]),
  });

  apply() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    this.context.completeWith(true);
  }

  cancel() {
    this.context.completeWith(false);
  }
}
